import { CSSProperties } from "react";

export const NOTE_MAX_LENGTH = 300;

export const pageCardStyle: CSSProperties = {
  border: "none",
  borderLeft: "1px solid rgba(25, 34, 46, 0.08)",
  borderRadius: "0",
  backgroundColor: "transparent",
};

export const pageCardBodyStyle: CSSProperties = {
  padding: 0,
  backgroundColor: "transparent",
};

export const pageContentStyle: CSSProperties = {
  padding: "20px 24px 24px",
};

export const sectionTitleStyle: CSSProperties = {
  color: "#19222E",
};

export const sectionSubtitleStyle: CSSProperties = {
  fontSize: "13px",
};

export const dividerStyle: CSSProperties = {
  borderColor: "#eef0f2",
};

export const settingCardStyle: CSSProperties = {
  border: "1px solid #eef0f2",
  borderRadius: "12px",
  height: "100%",
};

export const noteCardStyle: CSSProperties = {
  ...settingCardStyle,
  marginTop: "16px",
};

export const iconBadgeStyle: CSSProperties = {
  width: "40px",
  height: "40px",
  minWidth: "40px",
  borderRadius: "10px",
  backgroundColor: "rgba(94, 76, 217, 0.1)",
  color: "#5e4cd9",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
};

export const rowLabelStyle: CSSProperties = {
  color: "#19222E",
};

export const rowDescriptionStyle: CSSProperties = {
  fontSize: "13px",
};

export const rowSelectStyle: CSSProperties = {
  maxWidth: "260px",
};

export const noteCounterStyle: CSSProperties = {
  fontSize: "12px",
};
